import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import { ErrorKey } from '../app-active-error/ErrorKey';
import { LoadingKey } from '../app-active-loading/LoadingKey';
import { isExistingUserExistingAccount, isntExistingUserExistingAccount } from '../app/verificationTypeSelectors';
import { getGatesWithUrlOverrides } from '../auth/authUtils';
import { loginNewUser } from '../http-login/loginNewUser';
import { fetchGates } from '../http-survey/fetchGates';
import { handleLoginNewPortalFailure, handleLoginNewPortalSuccess } from '../http-survey/handleLoginNewPortalResponse';
import { handlePostSignupError } from '../http-survey/handlePostSignupResponse';
import { postSignup } from '../http-survey/postSignup';
import { FlowKeyToPartnerType } from '../solutions-provider/FlowKeyToPartnerType';
import { handleProvisionPartnerSuccess } from '../solutions-provider/handleProvisionPartnerSuccess';
import { provisionPartner } from '../solutions-provider/provisionPartner';
import { getIsNewPortalCreated } from '../store/app/selectors';
import { updateAuth } from '../store/auth/action-creators';
import { isPortalIdDefined } from '../store/auth/selectors';
import { setError } from '../store/error/action-creators';
import { isPartnerSignup } from '../store/flow/selectors';
import { Tracker } from '../store/tracking/action-creators';
import { EndpointKey } from './EndpointKey';
import { hasAnsweredAllQuestions, isNewLoggedInAccount, logInAndQuestionsCheck } from './endpointStateChecks';
export const EndpointsEndOfSignup = {
  [EndpointKey.LoginNewPortal]: {
    isStateOnlyTrigger: true,
    loadingKey: LoadingKey.LoginAfterSignup,
    once: true,
    stateCheck: state => getIsNewPortalCreated(state) && hasAnsweredAllQuestions(state) && isntExistingUserExistingAccount(state),
    method: loginNewUser,
    handleSuccess: (response, dispatch) => handleLoginNewPortalSuccess(dispatch),
    handleError: handleLoginNewPortalFailure
  },
  [EndpointKey.GateLookup]: {
    isStateOnlyTrigger: true,
    once: true,
    stateCheck: isNewLoggedInAccount,
    method: fetchGates,
    handleSuccess: (response, dispatch) => dispatch(updateAuth({
      gates: getGatesWithUrlOverrides(response)
    }))
  },
  [EndpointKey.PostSignup]: {
    isStateOnlyTrigger: true,
    loadingKey: LoadingKey.PostSignupLoading,
    once: true,
    stateCheck: state => logInAndQuestionsCheck(state),
    method: postSignup,
    handleError: handlePostSignupError
  },
  [EndpointKey.TrackSurveyCompleted]: {
    isStateOnlyTrigger: true,
    once: true,
    stateCheck: logInAndQuestionsCheck,
    method: (state, dispatch) => new Promise(resolve => {
      dispatch(Tracker.surveyCompleted());
      dispatch(Tracker.surveyInteraction());
      resolve(true);
    })
  },
  [EndpointKey.PartnerLookup]: {
    isStateOnlyTrigger: true,
    once: true,
    stateCheck: state => {
      return isPartnerSignup() && isExistingUserExistingAccount(state) && isPortalIdDefined(state);
    },
    method: state => {
      const flowKey = getFlowKey();

      if (flowKey === Flow.DirectoryListing || flowKey === Flow.SolutionsProvider) {
        return provisionPartner(FlowKeyToPartnerType[flowKey], state);
      }

      return Promise.reject(new Error('Invalid Partner Flow Key'));
    },
    loadingKey: LoadingKey.PartnerExistingAccount,
    handleSuccess: handleProvisionPartnerSuccess,
    handleError: (error, dispatch) => {
      //These error keys need to be updated once we have designs for the screens
      if (error && error.status && error.status === 'HUB_ALREADY_A_PARTNER') {
        dispatch(setError(ErrorKey.AlreadyAPartner));
      } else {
        dispatch(setError(ErrorKey.PartnerExistingAccountError));
      }
    }
  }
};